
































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AnalyseThrealtimedata from "../lostdataanalyse/analyse-lostdataanalyse.vue";
//import Echarts from "./Echarts.vue";

class PageThRealTimeDataRequest extends PageRequest {
  FilterText: string;
  etype:Number;
  StartTime: string;
  EndTime: string;
  cId: Number;
  AddTime: Date=new Date();
  mac: string;
  Time: string;
}
class PageCompanyRequest {
  cId: Number;
}
@Component({
  components: { AnalyseThrealtimedata },
})
export default class ThRealTimeDatas extends AbpBase {
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  analyseModalShow: boolean = false;
  userName: string;
  cId: Number;
  list1;
  mac:string='';
  wflocation:string='';
  selTime: Array<string>;
  selDateTime:Date=new Date();
  datalist1 = [];
  temp:string = ''
  humi = []
  StartTime:Date = new Date();
  EndTime:Date = new Date();
  AcqInt=0;
  // componentKey: number = 0;
  // datalist = [];
  // legenddata: string = "";
  // xAxisdata: string = "";
  // seriesdata: string = "";
  // serieslist = [];

  get list() {
    return this.$store.state.thdata.list;
  }
  get loading() {
    return this.$store.state.thdata.loading;
  }

  // showEcharts() {
  //   this.componentKey += 1;
  // }

  // onClickTime(value, date) {
  //   this.pagerequest.Time = value;
  // }
    onClickTime(value, date) {
    this.pagerequest.StartTime = value[0];
    this.pagerequest.EndTime = value[1];
  }
  selCompany(value: Number) {
    this.pagecompanyrequest.cId = value;
    this.getwarehouse();
    this.getfloor();
    this.getPage();
  }
  pageChange(page: number) {
    this.$store.commit("thdata/setCurrentPage", page);
    this.getPage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("thdata/setPageSize", pagesize);
    this.getPage();
  }
  async getPage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.pagerequest.etype = 1;
    //filters
    await this.$store.dispatch({
      type: "thdata/getLostDataList",
      data: this.pagerequest,
    });
  }

 
  get pageSize() {
    return this.$store.state.thdata.pageSize;
  }
  get totalCount() {
    return this.$store.state.thdata.totalCount;
  }
  get currentPage() {
    return this.$store.state.thdata.currentPage;
  }
  getuserName() {
    //console.log(this.$store.state.session.user);
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  factorylist(){
    return this.$store.state.factory.list;
  }
  get thequipment() {
    return this.$store.state.thequipment.list;
  }
  thequipmentlist() {
    return this.$store.state.thequipment.list;
  }

  thdatalist() {
    return this.$store.state.thdata.list;
  }

  get thdata() {
    return this.$store.state.thdata.list;
  }
  get smokecrib() {
    return this.$store.state.smokecrib.list;
  }
  smokecriblist(){
    return this.$store.state.smokecrib.list;
  }
  analyse() {
    this.selDateTime=this.pagerequest.AddTime;
    this.EndTime = new Date (this.pagerequest.EndTime);
    this.StartTime = new Date(this.pagerequest.StartTime);
    this.analyseModalShow = true;
  }
  setmac(val,actInt){
    this.mac=val;
    this.AcqInt = actInt;
  }
  setNames(paramftid,paramwid,paramfid,paramlocation){
    let ftid = paramftid;
    let wid = paramwid;
    let fid = paramfid;
    let ftlist = this.factorylist(); 
    for (let entry of ftlist) {
      if(ftid==entry.id){
        ftid=entry.fName;
        break;
      }
    }
    let wlist = this.warehouselist(); 
    for(let entry of wlist) {
      if(wid==entry.id){
        wid=entry.wName;
        break;
      }
    }
    let flist = this.floorlist();
    for(let entry of flist){
      if(fid == entry.id){
        fid = entry.fName;
        break;
      }
    }
    this.wflocation =ftid + wid + fid + paramlocation + "数据分析";
    if(ftid == 0){
      this.wflocation =wid + fid + paramlocation + "数据分析";
    }

  }

  columns = [
     {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          if (cId == entry.id) {
            cId = entry.cName;
            break;
          }
        }
        if (cId == 0) {
          cId = "";
        }
        return h("span", cId);
      },
    },
     {
      title: "库区",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist(); 
        for (let entry of flist) {
          if(Id==entry.id){
            Id=entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    }, 
    {
      title: "库房",
      key: "wId",
      render: (h, params) => {
        let wId = params.row.wId;
        let wlist = this.warehouselist();
        for (let entry of wlist) {
          //console.log(entry.id); // 1, "string", false
          if (wId == entry.id) {
            wId = entry.wName;
            break;
          }
        }
        return h("span", wId);
      },
    },
    {
      title: "楼层",
      key: "fId",
      render: (h, params) => {
        let fId = params.row.fId;
        let flist = this.floorlist();
        for (let entry of flist) {
          //console.log(entry.id); // 1, "string", false
          if (fId == entry.id) {
            fId = entry.fName;
            break;
          }
        }
        return h("span", fId);
      },
    },
    {
      title: "SN号",
      key: "mac",
    },
     {
      title: "烟叶",
      key: "scId",
      render: (h, params) => {
        let scId = params.row.scId;
        let clist = this.smokecriblist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(scId==entry.id){
            scId=entry.title;
            break;
          }
        }
        return h("span", scId);
      },
    },
    {
      title: "位置",
      key: "locationName",
    },
    {
      title: "剩余电量",
      key: "electric",
      render: (h, params) => {
        return h("span", params.row.electric+'%');
      },
    },
    {
      title:"丢包率",
      key:"counts",
      render:(h,params) => {
        let counts = params.row.counts;
        let acqInt = 0;
        acqInt = params.row.acquisitionInterval;
        if(acqInt !=0){
        let returns = "";
        let date1 = new Date(this.pagerequest.StartTime);
        let date2 = new Date(this.pagerequest.EndTime);
        let days = (date2.getTime() - date1.getTime())/1000/60/60/24;
        let totalnum = Math.round(60 / acqInt * 24 * days);
        if(counts > (totalnum * days)){
          returns = "0%";
        }
        else{
          counts = (totalnum - counts) / totalnum * 100
          counts = Math.round(counts);
          returns=counts.toString() + "%";
        }
        return h("span",returns);
        }
        else{
          return h("span","时间间隔为0")
        }
        

      }
    },
    // {
    //   title: "温度",
    //   key: "temp",
    //    render: (h, params) => {
    //        var temp = params.row.temp1 + "℃";         
    //     return h("span",{style:"white-space: pre-wrap"}, temp);
    //   },
    // },
    // {
    //   title: "湿度",
    //   key: "humi",
    //    render: (h, params) => {
    //     var humi = params.row.humi1 + "%";
    //     return h("span",{style:"white-space:pre-wrap"}, humi);
    //   },
    // },
    // {
    //   title: "更新时间",
    //   key: "addTime",
    //   render: (h, params) => {
    //     let addTime ='';
        
    //     addTime=this.GetDay(params.row.addTime)+'\n'+this.GetMinutes(params.row.addTime);
    //     return h("span",{style:"white-space: pre-wrap"}, addTime);
    //   },
    // },
    {
      title: "操作",
      key: "Actions",
      width: 100,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "2px",
              },
              on: {
                click: () => {
                  
                  //this.mac=params.row.mac;
                 this.setmac(params.row.mac,params.row.acquisitionInterval);
                 this.setNames(params.row.ftId,params.row.wId,params.row.fId,params.row.locationName);
                  this.$store.commit("thdata/lostanalyse", params.row);
                   //console.log(this.mac+'aaa');
                  this.analyse();
                },
              },
            },
            "数据分析"
          ),
         
        ]);
      },
    },
  ];

  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll",
    });
  }

  GetDay(time) {
    let date = new Date(time);
    let Str = date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();
    return Str;
  }

  GetMinutes(time) {
    let date = new Date(time);
    let Str = this.GetBqMinutes(date.getHours()) + ":" + this.GetBqMinutes(date.getMinutes());
    return Str;
  }
GetBqMinutes(str){
    if(str.toString().length==1){
      return '0'+str;
    }
    return str;
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfactory(){
      //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
  async getsmokecrib() {
    //烟叶
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getAll",
       data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
  }
    GetTime(obj) {
    let date = new Date();
    let day = "01";
    if (obj == 1) {
      day = date.getDate() + "";
    }
    let Str = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + day;
    //date.getDate();
    return Str;
  }
  created() {
     this.$store.state.thdata.pageSize=10;
    this.$store.state.thdata.currentPage=1;
    this.$store.state.thdata.totalCount=0;
      this.pagerequest.StartTime = this.GetTime(0);
    this.pagerequest.EndTime = this.GetTime(1);
    this.selTime = [this.pagerequest.StartTime, this.pagerequest.EndTime];
    this.getuserName();
    if (this.userName !== "admin") {
      this.getwarehouse();
      this.getfloor();
      this.getfactory();
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    } else {
      this.getcompany();
    }

    this.getPage();
  }
}
